import React from "react";
import "./index.css";
class Spinner extends React.PureComponent {
  render() {
    return (
      <div>
        <div className="showbox" id="loader">
          <div className="loader"></div>
        </div>
      </div>
    );
  }
}
export default Spinner;
